export enum ProjectIs {
  UTMC = 'UTMC',
  STOPCLAIMS = 'STOPCLAIMS',
  ACME = 'ACME',
}

export enum ProjectEnvironment {
  DEV = 'DEV',
  UAT = 'UAT',
  PROD = 'PROD',
}

export enum ProjectProfile {
  DEFAULT = 'DEFAULT',
  UTMC = 'UTMC',
  STOPCLAIMS = 'STOPCLAIMS',
  ACME = 'ACME',
}

export interface Environment {
  production: boolean;
  docInsightsWidgetKey: string;
  configSecretKey: string;
}
